import { render, staticRenderFns } from "./VerCliente.vue?vue&type=template&id=61895872&scoped=true&"
import script from "./VerCliente.vue?vue&type=script&lang=js&"
export * from "./VerCliente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61895872",
  null
  
)

export default component.exports